import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';

import axios from "axios";
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';

const ViewStatement = () => {

    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [statementData, setStatementData] = useState([]);
    const [balanceData, setBalanceData] = useState([]);
    const [totalDebit, setTotalDebit] = useState(0);  // New state for total debit
    const [totalCredit, setTotalCredit] = useState(0);  // New state for total credit

    // Fetch client list from API
    useEffect(() => {
        axios.get("https://react-apis.dotlocalhost.com/showClients.php").then((response) => {
            setClients(response.data);
        });
    }, []);

    // Fetch statement data based on selected client
    useEffect(() => {
        if (selectedClient) {
            axios
                .get(`https://react-apis.dotlocalhost.com/showClientData.php?clid=${selectedClient}`)
                .then((response) => {
                    console.log("API Response Data:", response.data);
                    const data = response.data;
                    if (Array.isArray(data)) {
                        calculateBalance(data);
                    } else {
                        console.error("Data is not an array:", data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching client data:", error);
                });
        }

        // sidebar background color set
        const sidebarItemmain = document.getElementById("accnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9";
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("vwstmnt");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7";
            sidebarItem.style.color = "#000000";
        }

        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = "";
                sidebarItemmain.style.color = "#000000";
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = "";
                sidebarItem.style.color = "#000000";
            }
        };
    }, [selectedClient]);

    // Function to calculate balance and totals
    const calculateBalance = (data) => {
        console.log("Calculating balance for data:", data);
        let balance = parseFloat(data[0].balance) || 0; // Initialize balance with opening_balance
        let totalDebitAmount = 0;  // To hold the total debit amount
        let totalCreditAmount = 0; // To hold the total credit amount

        const calculatedData = data.map((row, index) => {
            // Skip balance calculation for the first row (opening balance)
            if (index === 0) return row;

            const debit = parseFloat(row.debit) || 0;
            const credit = parseFloat(row.credit) || 0;
            balance = balance + credit - debit;

            // Add to total debit and credit
            totalDebitAmount += debit;
            totalCreditAmount += credit;

            return { ...row, balance: balance.toFixed(2) };
        });

        // Set the balance data and totals
        setBalanceData(calculatedData);
        setTotalDebit(totalDebitAmount);
        setTotalCredit(totalCreditAmount);

        console.log("Calculated statement data:", calculatedData);
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>View Statement</h3>
                        </div>
                    </div>

                    <div>
                        <div className='row mb-5'>
                            <div className='col-3'>
                                <label className="form-label"><b>Client Name</b></label>
                                <select className='form-control' value={selectedClient} onChange={(e) => setSelectedClient(e.target.value)}>
                                    <option value="">-- Select Client --</option>
                                    {clients.map((client) => (
                                        <option key={client.id} value={client.clid}>
                                            {client.clientName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Check if balanceData is populated */}
                        {balanceData.length > 0 ? (
                            <Table striped bordered hover style={{ fontSize: '12px' }}>
                                <thead>
                                    <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                        <th>Date</th>
                                        <th>Particulars</th>
                                        <th>Debit</th>
                                        <th>Credit</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {balanceData.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.date}</td>
                                            <td>{row.particulars}</td>
                                            <td>{row.debit}</td>
                                            <td>{row.credit}</td>
                                            <td>{row.balance}</td>
                                        </tr>
                                    ))}
                                    {/* Add a row for total debit and credit */}
                                    <tr style={{ backgroundColor: '#e9ecef', fontWeight: 'bold' }}>
                                        <td colSpan="2">Total</td>
                                        <td>{totalDebit.toFixed(2)}</td>
                                        <td>{totalCredit.toFixed(2)}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </Table>
                        ) : (
                            <p>No statement data available for this client.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewStatement;
